module.exports = __webpack_public_path__ + "static/img/A99.b67a04bb.jpg";